<template>
    <div>
        <super-header
            class="mb-5"
        ></super-header>
        <div>
            <div
                class="mb-5"
            >
                <h3
                    class="text-3xl font-bold text-gray-500"
                >
                    <slot name="title" />
                </h3>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import SuperHeader from '@/js/components/super/SuperHeader.vue';
export default {
    components: {
        SuperHeader,
    },
}
</script>